import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, CardBody } from "react-bootstrap";
import { buildPortfolioGuruPath } from "../../utils/guruRoute";

export default function HomeHero({ data, onReady }) {
  const [investors, setInvestors] = useState([]);
  const [nickname, setNickname] = useState("");
  const [leader, setLeader] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [returnYear, setReturnYear] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeId, setActiveId] = useState(0);
  const readyNotifiedRef = useRef(false);
  const navigate = useNavigate();

  const notifyReady = () => {
    if (readyNotifiedRef.current) {
      return;
    }

    readyNotifiedRef.current = true;
    if (typeof onReady === "function") {
      onReady();
    }
  };

  // set 투자대가 데이터 
  useEffect(() => {
    setInvestors(Array.isArray(data) ? data : []);
    setActiveId(0);
    setLoading(false);
    readyNotifiedRef.current = false;
  }, [data]);

  // 초기값 세팅
  useEffect(() => {
    if (investors.length === 0) {
      setNickname("");
      setLeader("");
      setImagePath("");
      setReturnYear("");
      return;
    }

    const currentInvestor = investors[activeId] || investors[0];
    const guruId = currentInvestor?.guruid;
    setImagePath(guruId !== undefined && guruId !== null ? `/images/webp/${encodeURIComponent(String(guruId))}.webp` : "")
    setNickname(currentInvestor.nickname);
    setLeader(currentInvestor.leader);
    setReturnYear(Number(currentInvestor.return365).toFixed(2));
  }, [investors, activeId]);

  // 5초마다 다음 투자대가로 자동 순환
  useEffect(() => {
    if (investors.length <= 1) {
      return;
    }

    const intervalId = setInterval(() => {
      setActiveId((prevIndex) => (prevIndex + 1) % investors.length);
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [investors.length]);

  return (
    <>
      {!loading ? (
        <>
          <Card>
            <CardBody>
              <Row>
                <Col sm="12" md="6" lg="6">
                  <div className="home-hero-photo mb-3">
                    {investors.length > 0 ? (
                      <>
                        <img
                          src={imagePath}
                          alt={nickname}
                          onLoad={notifyReady}
                          onError={notifyReady}
                          className="no-copy"
                        />
                        <div className="home-hero-caption">
                          <div className="home-hero-caption-row">
                            <div className="home-hero-identity">
                              <div className="home-hero-nickname">{nickname}</div>
                              {leader && <div className="home-hero-leader">{leader}</div>}
                            </div>
                            <div className="home-hero-return">
                              <span className={`home-hero-return-value is-positive`}>
                                {returnYear} %
                              </span>
                              <span className="home-hero-return-label">1년 수익률</span>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="home-insider-placeholder">표시할 투자 대가가 없습니다.</div>
                    )}
                  </div>
                </Col>
                <Col sm="12" md="6" lg="6">
                  <div className="home-hero-left">
                    <div className="home-top-header">
                      <div className="home-top-title">TOP 포트폴리오</div>
                      <button
                        type="button"
                        className="home-section-link"
                        onClick={() => navigate("/guru")}
                      >
                        전체보기
                      </button>
                    </div>
                    <div className="home-top-subtitle">13F 공시가 난 다음날 TOP10종목을 따라 샀어요</div>
                    <div className="home-top-list">
                      {loading && investors.length === 0 ? (
                        <div className="home-top-empty">투자 대가를 불러오는 중...</div>
                      ) : investors.length === 0 ? (
                        <div className="home-top-empty">표시할 투자 대가가 없습니다.</div>
                      ) : (
                        investors.map((investor, index) => (
                          <button
                            key={index}
                            type="button"
                            className={`home-top-item${index === activeId ? " is-active" : ""}`}
                            onClick={() => {
                              setActiveId(index);
                              navigate(buildPortfolioGuruPath("guru", investor));
                            }}
                          >
                            <div className="home-top-main">
                              <span className="home-top-rank">{String(index + 1).padStart(2, "0")}</span>
                              <div className="home-top-info">
                                <div className="home-top-name">{investor.leader}</div>
                                {investor.institution && <div className="home-top-inst">{investor.institution}</div>}
                              </div>
                            </div>
                            <div className="home-top-return">
                              <span className="home-top-return-label">1년 수익률</span>
                              <span className={`home-top-return-value is-positive`}>
                                {Number(investor.return365).toFixed(2)} %
                              </span>
                            </div>
                          </button>
                        ))
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </>
      ) : (
        <div>
          데이터 로딩 중
        </div>
      )}
    </>
  );
}
